<div class="spinner-loading" id="spinner">
    <span class="spinner-border" role="status">
    </span>
</div>